import { trackPromise } from 'react-promise-tracker';
import { ReactTrackerAreas } from 'src/enums/reactTrackerAreas.enum';
import api from './index';

export const ComparableAPI = {
  getComparable: (data): Promise<any> => trackPromise(api.post('/v2/properties/comps', data), ReactTrackerAreas.GET_COMPARABLE)
};
